import type React from 'react'

export const affiliateMutedText = '#dbeafe'
export const affiliateSubtleText = '#bfd3ff'

/** @deprecated Prefer CSS classes on .htd-aff__panel */
export const affiliateCardShell: React.CSSProperties = {}

export function affiliateTopRankClass(index: number): string {
  if (index === 0) return 'htd-aff__rank htd-aff__rank--gold'
  if (index === 1) return 'htd-aff__rank htd-aff__rank--silver'
  if (index === 2) return 'htd-aff__rank htd-aff__rank--bronze'
  return 'htd-aff__rank'
}
